// The host the viewer talks to, and its viewer ID (visiodocs-app#655).
// Online: the app, on one of the listed hosts or a local one, with ?ID= in the viewer's URL.
// Offline: only the bundle viewer page's srcdoc iframe; its origin is "null", so the hello goes to '*' with ID 0.

// Offline the list is empty: only the srcdoc iframe is accepted there, and the one file then names no Firebase
// project (scripts/inline-offline.js refuses one). `typeof`, because the tests run this file without webpack's OFFLINE
const allowedHosts = new Set(typeof OFFLINE !== 'undefined' && OFFLINE ? [] : [
    'app.visiodocs.com',
    'staging.visiodocs.com',
    'development.visiodocs.com',
    'visiodocs-aaff0.web.app',
    'visiodocs-aaff0.firebaseapp.com',
    'docavea-prod.web.app',
    'docavea-prod.firebaseapp.com',
    'docavea2-eu.web.app',
    'docavea2-eu.firebaseapp.com',
    'docavea-staging.web.app',
    'docavea-staging.firebaseapp.com',
    'docavea-henrik.web.app',
    'docavea-henrik.firebaseapp.com',
]);

// Where to post the hello, and the viewer's ID; null when this host may not talk to the viewer
export function resolveHost(referrer: string, href: string, offline: boolean): { targetOrigin: string; id: number } | null {
    if (offline) {
        if (href === 'about:srcdoc') {
            return { targetOrigin: '*', id: 0 };
        }
        console.error('Offline viewer outside a srcdoc iframe', href);
        return null;
    }

    let url: URL;
    try {
        url = new URL(referrer);
    } catch (error) {
        console.error('Invalid URL', referrer);
        return null;
    }
    const isLocalhost = url.hostname === 'localhost' || url.hostname.startsWith('192.168.');
    if (!allowedHosts.has(url.hostname) && !isLocalhost) {
        console.error('Unknown host', referrer);
        return null;
    }

    const id = new URL(href).searchParams.get('ID');
    if (!id) {
        console.error('ID parameter not found in URL');
        return null;
    }
    return { targetOrigin: url.origin, id: +id };
}
